import * as RadixSwitch from '@radix-ui/react-switch'
import { cx } from 'class-variance-authority'
import type { ComponentPropsWithoutRef } from 'react'
import { forwardRef } from 'react'

import styles from './Switch.module.scss'

export interface SwitchProps
  extends Omit<ComponentPropsWithoutRef<typeof RadixSwitch.Root>, 'children'> {
  label: string
  className?: string
  warning?: boolean
}

export const Switch = forwardRef<HTMLButtonElement, SwitchProps>(
  ({ label, className, warning = false, ...props }, ref) => (
    <label className={cx(styles.wrapper, className)} data-warning={warning}>
      <RadixSwitch.Root
        className={styles.root}
        data-warning={warning}
        ref={ref}
        {...props}
      >
        <RadixSwitch.Thumb className={styles.thumb} />
      </RadixSwitch.Root>
      <span className={styles.labelText}>{label}</span>
    </label>
  )
)

Switch.displayName = 'Switch'
